import { useQuery } from '@tanstack/react-query';
import { handleApiResponse } from '@/functions';
import { apiClient } from '@/components/api';
import routes from '@/lib/routes';

export interface ICountryResult {
  _id: string;
  iso3: string;
  iso2: string;
  name: string;
}

export const useRequestSearchCountries = (searchTerm: string, enabled: boolean) => {
  const { data, isFetching } = useQuery<ICountryResult[]>({
    queryKey: ['countries-search', searchTerm],
    queryFn: () =>
      apiClient
        .get<ICountryResult[]>(routes.api.geolocationSearch, { text: searchTerm, country: true })
        .then(handleApiResponse)
        .then(res => res ?? []),
    enabled: enabled && searchTerm.trim().length > 0,
    staleTime: 60_000,
  });

  return { countries: data ?? [], isLoading: isFetching };
};
